export default __webpack_public_path__ + "static/autocapture-light-b95667237b00e1b984cd8815e56ebe23.png";